function loadScript(file) {
  const DOC = document.getElementsByTagName('head')[0];
  const js = document.createElement('script');
  js.setAttribute('type', 'text/javascript');
  js.setAttribute('src', file);
  DOC.appendChild(js);
  return new Promise(resolve => {
    if (document.all) {
      //如果是IE     
      js.onreadystatechange = function () {
        if (js.readyState == 'loaded' || js.readyState == 'complete') {
          resolve();
        }
      };
    } else {
      js.onload = function () {
        resolve();
      };
    }
  });
}

function loadCSS(file) {
  const head = document.getElementsByTagName('head')[0];
  const link = document.createElement('link');
  link.type = 'text/css';
  link.rel = 'stylesheet';
  link.href = file;
  head.appendChild(link);
}

function loadResolve(file) {
  if (/\.js$/.test(file)) {
    return loadScript(file);
  } else if (/\.css$/.test(file)) {
    return loadCSS(file);
  }
}
function getUnitRatio(pricingCycle = '') {
  pricingCycle = pricingCycle.toLowerCase();
  if (pricingCycle == 'month') {
    return 1;
  } else if (pricingCycle == 'year') {
    return 12;
  } else {
    return 1;
  }
}

export default function getDuration(period, pricingCycle) {
  return parseInt(period) * getUnitRatio(pricingCycle);
}
export {
  loadResolve,
  loadScript,
  loadCSS,
  getDuration
};


// WEBPACK FOOTER //
// ./lib/services/utils.js